angular.module('clientDashboardApp').service('reportService', function( $q, $http, cacheService ){

   function ReportService() {
    }

    ReportService.prototype.getReportFeatures = function () {
        return $http.get('/v5/reports/features');
    };


    ReportService.prototype.getReportConfs = function (refresh) {
        return  $http.get('/v5/reports');
    };


    ReportService.prototype.updateReportConf = function (reportConf) {
        return $http.post('/v5/reports', reportConf);
    };

    var reportService = new ReportService();
    return reportService;

});
